export default __webpack_public_path__ + "static/media/Shopify.7cdb7f94.svg";